import axios from "axios";
import { API } from "@/lib/api";

const PORTAL_TOKEN_KEY = "hw_portal_token";

export const getPortalToken = () => {
  try { return localStorage.getItem(PORTAL_TOKEN_KEY); } catch { return null; }
};
export const setPortalToken = (t) => {
  try {
    if (t) localStorage.setItem(PORTAL_TOKEN_KEY, t);
    else localStorage.removeItem(PORTAL_TOKEN_KEY);
  } catch { /* unavailable */ }
};
export const clearPortalToken = () => setPortalToken(null);

export const portalApi = axios.create({
  baseURL: API,
  withCredentials: false,
});

portalApi.interceptors.request.use((config) => {
  const t = getPortalToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// When the portal token expires, send the Care Seeker to the friendly
// "ask your Care Navigator for a new link" screen — never to the staff
// /login page.
portalApi.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401 && typeof window !== "undefined") {
      clearPortalToken();
      if (!window.__hw_portal_redirecting) {
        window.__hw_portal_redirecting = true;
        window.location.replace("/portal/expired");
      }
    }
    return Promise.reject(err);
  },
);
